import Popup from 'reactjs-popup';
import viewIcon from '../../../assets/view.png';
import EditPopup from './Edit.jsx';

const ShowPopup = ({ item, trigger }) => {
    const guardianName = [item.guardian_first_name, item.guardian_last_name]
        .filter(Boolean)
        .join(' ');

    const hasAttributes = item.visitor_is_minor || item.person_is_guardian || item.person_will_invite_others || item.person_is_visitor;
    const showContactInfo = !item.visitor_is_minor && (item.visitor_email || item.visitor_phone);

    return (
        <Popup trigger={trigger ?? <img src={viewIcon} />} modal nested>
            {close => (
                <div className="floatBody">
                    <div className="floatSignupForm">
                        <form className="floatForm">
                            <div className="float-header">View person</div>

                            <div className="float-main">

                                <div className="view-field">
                                    <div className="view-field__label">First Name</div>
                                    <div className="view-field__value">
                                        {item.visitor_first_name || <span className="view-field__empty">—</span>}
                                    </div>
                                </div>

                                <div className="view-field">
                                    <div className="view-field__label">Last Name</div>
                                    <div className="view-field__value">
                                        {item.visitor_last_name || <span className="view-field__empty">—</span>}
                                    </div>
                                </div>

                                <div className="view-field">
                                    <div className="view-field__label">Organization</div>
                                    <div className="view-field__value">
                                        {item.visitor_org_name || <span className="view-field__empty">—</span>}
                                    </div>
                                </div>

                                {hasAttributes && (
                                    <>
                                        <hr className="view-divider" />
                                        <div className="view-badges">
                                            {item.visitor_is_minor         && <span className="visitor-tag visitor-tag--minor">Minor</span>}
                                            {item.person_is_guardian       && <span className="visitor-tag visitor-tag--guardian">Guardian</span>}
                                            {item.person_will_invite_others && <span className="visitor-tag visitor-tag--inviter">Inviter</span>}
                                            {item.person_is_visitor && !item.visitor_is_minor && <span className="visitor-tag visitor-tag--visitor">Visitor</span>}
                                        </div>
                                    </>
                                )}

                                {item.visitor_is_minor && (
                                    <div className="view-field">
                                        <div className="view-field__label">Guardian</div>
                                        <div className="view-field__value">
                                            {guardianName || <span className="view-field__empty">—</span>}
                                        </div>
                                    </div>
                                )}

                                {showContactInfo && (
                                    <>
                                        <hr className="view-divider" />
                                        {item.visitor_email && (
                                            <div className="view-field">
                                                <div className="view-field__label">Email</div>
                                                <div className="view-field__value">{item.visitor_email}</div>
                                            </div>
                                        )}
                                        {item.visitor_phone && (
                                            <div className="view-field">
                                                <div className="view-field__label">Phone</div>
                                                <div className="view-field__value">{item.visitor_phone}</div>
                                            </div>
                                        )}
                                    </>
                                )}

                            </div>

                            <div className="float-footer">
                                <div className="formButtons">
                                    <EditPopup
                                        item={item}
                                        trigger={
                                            <button className="button save view-edit-btn" type="button">
                                                Edit
                                            </button>
                                        }
                                    />
                                    <button className="button cancel" type="button" onClick={close}>
                                        Close
                                    </button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            )}
        </Popup>
    );
};

export default ShowPopup;
